<template>
	<sf-data-table
		ref="grpTable"
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="cols"
		:rows="rows"
		:stripe="false"
		:selection="false"
		:span-method="spanMethod"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'bfRslt'">
				<template v-if="slotProps.row.itemCd == '20' || slotProps.row.itemCd == '30'">
					<td
						class="col-1"
						style="all: unset; cursor: pointer; text-align: right"
						@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
					>
						{{ slotProps.row[slotProps.column.property] }}
					</td>
				</template>
				<template v-else>
					{{ slotProps.row[slotProps.column.property] }}
				</template>
			</template>
			<template v-if="slotProps.column.property === 'cuRslt'">
				<template v-if="slotProps.row.itemCd == '20' || slotProps.row.itemCd == '30'">
					<td
						class="col-1"
						style="all: unset; cursor: pointer; text-align: right"
						@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
					>
						{{ slotProps.row[slotProps.column.property] }}
					</td>
				</template>
				<template v-else>
					{{ slotProps.row[slotProps.column.property] }}
				</template>
			</template>
			<template v-for="(item, index) in monthlabel">
				<template v-if="slotProps.column.property === item">
					<template v-if="slotProps.row.itemCd == '20' || slotProps.row.itemCd == '30'">
						<td
							:key="index"
							class="col-1"
							style="all: unset; cursor: pointer; text-align: right"
							@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
						>
							{{ slotProps.row[slotProps.column.property] }}
						</td>
					</template>

					<template v-else>
						{{ slotProps.row[slotProps.column.property] }}
					</template>
				</template>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcIdxNum12M/store/helpers';

import PcRoList from '@mqy/clma/PcRoList/PcRoList.vue';
import CarSale from '@mqy/qlty/CarSale/CarSale.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			monthlabel: '',
			cuRslt: '',
			bfRslt: ''
		};
	},
	created() {
		this.monthlabel = this.monthlabel_;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdSalesList;
		},
		cols() {
			return this.dayCols_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		async onGoClick(argsCnt, rowsInfo) {
			let selCnt = argsCnt;

			//값이 없을땐 이동을 못함.
			if (selCnt == 0 || selCnt == '') {
				return false;
			}

			//대상대수
			let name = ''; //R/O리스트
			let selScrId = ''; //스크린 ID
			let selMsgKey = '';
			let selComponent = '';

			let pStartDt = ''; //시작일자
			let pEndDt = ''; //종료일자
			let pState1 = ''; //부품유형
			let pState2 = ''; //차량구분
			let pState3 = ''; //승상구분
			let pState4 = ''; //연료전지사양
			let pState5 = ''; //판매지역
			let pState6 = ''; //사용기간(1m,2m,3m,12m,WM)
			let pState7 = ''; //사용기간(1m,2m,3m,12m,WM)
			let pState8 = ''; //사용기간(1m,2m,3m,12m,WM)
			let pState9 = ''; //사용기간(1m,2m,3m,12m,WM)
			let pState10 = '';
			let pState11 = ''; //검색조건 HTWO판매월
			let pState12 = ''; //검색조건 조건월
			let pState14 = ''; //사용기간(1m,2m,3m,12m,WM)
			let pState13 = '';
			let pState18 = '10'; //정비유형 보증수리인것만

			let baseYyyy = this.searchParams.searchDate; //검색하는 기준년도

			let tmpYear = this.$moment(baseYyyy + '0101')
				.subtract(1, 'years')
				.format('YYYYMMDD');

			//return false;

			if (rowsInfo.row.itemCd == '20') {
				if (rowsInfo.column.labelClassName == 'bfRslt') {
					//기준년도에 -2년 01월부터 12월
					pStartDt = this.$moment(baseYyyy + '0101')
						.subtract(2, 'y')
						.format('YYYYMMDD'); //시작일자

					pEndDt =
						this.$moment(baseYyyy + '0101')
							.subtract(2, 'y')
							.format('YYYY') + '1231'; //종료일자
				} else if (rowsInfo.column.labelClassName == 'cuRslt') {
					//기준년도 -1년 1월 12월
					pStartDt = this.$moment(baseYyyy + '0101')
						.subtract(1, 'y')
						.format('YYYYMMDD');
					pEndDt =
						this.$moment(baseYyyy + '0101')
							.subtract(1, 'y')
							.format('YYYY') + '1231'; //종료일자; //종료일자
				} else {
					//기준년도1년
					// pStartDt = this.$moment(rowsInfo.column.labelClassName).subtract(1, 'y').startOf('month').format('YYYYMMDD'); //시작일자
					// pEndDt = this.$moment(rowsInfo.column.labelClassName).subtract(1, 'y').endOf('month').format('YYYYMMDD'); //종료일자
					let ss = this.$moment(rowsInfo.column.labelClassName).format('YYYYMM');
					pStartDt = this.$moment(ss).subtract(12, 'M').startOf('month').format('YYYYMMDD'); //시작일자
					pEndDt = this.$moment(ss).subtract(12, 'M').endOf('month').format('YYYYMMDD'); //종료일자
					//console.log('else', pEndDt);
				}

				name = this.getMessage_('QWCC001590'); //R/O리스트
				selScrId = this.pcRoListScrId; //RO리스트조회
				selMsgKey = 'QWCC001590'; //R/O리스트
				selComponent = PcRoList; //R/O리스트 Vue 파일

				pState1 = this.searchParams.partType; //부품유형
				pState2 = this.searchParams.carScn; //차량구분
				pState3 = this.searchParams.pacScn; //승상구분
				pState4 = this.searchParams.flclSpc; //연료전지사양
				pState5 = rowsInfo.row.saleRegn; //판매지역
				pState6 = '12M'; //사용기간(1m,2m,3m,12m,WM)
				pState7 = '30'; //RO처리단계
				pState8 = '10'; //RO처리결과
				pState9 = 'W'; //Ctype
				pState10 = this.searchParams.carTypeNm;
				pState11 = '30'; //HTWO판매월
				pState12 = ''; //조건월
				pState14 = '12M'; //(1m,2m,3m,12m,WM)
				pState18 = '10'; //정비유형
				pState13 = '04';

				//console.log('pStartDt>>>', pStartDt);
				//console.log('pEndDt>>>', pEndDt);
				// console.log('pState6>>>', pState6);
				//console.log('pState10>>>', pState10);
			} else if (rowsInfo.row.itemCd == '30') {
				//PMC판매정보로 가야된다.

				if (rowsInfo.column.labelClassName == 'bfRslt') {
					pStartDt = this.$moment(baseYyyy + '0101')
						.subtract(1, 'years')
						.format('YYYYMMDD'); //시작일자

					pEndDt =
						this.$moment(baseYyyy + '0101')
							.subtract(1, 'years')
							.format('YYYY') + '1231'; //종료일자
				} else if (rowsInfo.column.labelClassName == 'cuRslt') {
					pStartDt = this.$moment(baseYyyy + '0101').format('YYYYMMDD'); //시작일자
					pEndDt = this.$moment(baseYyyy + '0101').format('YYYY') + '1231'; //종료일자
				} else {
					pStartDt = this.$moment(rowsInfo.column.labelClassName+'01').startOf('month').format('YYYYMMDD') +'01'; //시작일자
					pEndDt = this.$moment(rowsInfo.column.labelClassName+'01').endOf('month').format('YYYYMMDD'); //종료일자
				}

				name = this.getMessage_('QWCC001899'); //PMC 판매정보
				selScrId = this.pmcSaleListScrId; //pmc판매정보
				selMsgKey = 'QWCC001899'; //pmc 판매정보
				selComponent = CarSale; //pmc 판매정보 Vue파일

				pState1 = this.searchParams.carScn; //차량구분
				pState2 = this.searchParams.pacScn; //승상구분
				pState3 = this.searchParams.flclSpc; //연료전지사양
				pState4 = rowsInfo.row.saleRegn; //판매지역
				pState5 = '30'; //날짜구분
				pState6 = '12M'; //사용기간(1m,2m,3m,12m,WM)
				pState14 = '12M'; //(1m,2m,3m,12m,WM)
				pState10 = this.searchParams.carTypeNm;
				pState13 = '04';
				// console.log('pState6>>>', pState6);
				//console.log('pState10>>>', pState10);
			} else {
				return false;
			}

			//console.log(' this.pcRoListScrId', this.pcRoListScrId);
			//console.log(' this.pmcSaleListScrId', this.pmcSaleListScrId);
			let item = {
				name,
				component: selComponent, //import할 컴포넌트 이름
				scrId: selScrId, //이동할 scr
				msgKey: selMsgKey //R/O리스트
			};

			//console.log('item', item);
			// console.log('pState6>>>', pState14);
			//console.log('pState10>>>', pState10);
			await this.getScreen_({ scrId: item.scrId });
			await this.$sf_removeTab(item.scrId);
			await this.$sf_addTab(item, item.scrId, {
				scrId: item.scrId,
				pStartDt,
				pEndDt,
				pState1,
				pState2,
				pState3,
				pState4,
				pState5,
				pState6,
				pState7,
				pState8,
				pState9,
				pState10,
				pState11,
				pState12,
				pState14,
				pState13,
				pState18
			});
		},
		spanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				if (rowIndex % 3 === 0) {
					return {
						rowspan: 3,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		}
	}
};
</script>

<style></style>
